import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { downloadPacks } from '@/mocks/home';

export default function DownloadHub() {
  return (
    <section id="downloads" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="一键取走"
          icon="ri-download-cloud-2-line"
          title="爱黑料网打包 · 下载入口"
          desc="按周整理成压缩包，附目录索引与高清原图编号，解压后能直接定位到要看的那一套。"
          action="查看全部打包"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr]">
          <Reveal>
            <div className="relative flex h-full flex-col justify-end overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20stacked%20archive%20boxes%20and%20labelled%20paper%20folders%20on%20a%20linen%20desk%2C%20muted%20terracotta%20and%20amber%20palette%2C%20soft%20window%20light%2C%20minimal%20flat%20lay%20composition%2C%20no%20readable%20text&width=1000&height=760&seq=ahh-download-hero&orientation=landscape"
                alt="爱黑料网打包资源下载区"
                title="爱黑料网打包 · 资源库下载入口"
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10"></div>

              <div className="relative p-6 md:p-8">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-award-line text-[13px]"></i>
                  </span>
                  本周头号资源
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
                  927 号合集包 · 完整目录版
                </h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-background-50/80">
                  收录近一周热度最高的 186 套图文集，压缩包内含分类目录与编号索引，解压即可顺着看。
                </p>

                <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-50/80">
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-hard-drive-2-line text-[13px]"></i>
                    </span>
                    3.42 GB
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-file-zip-line text-[13px]"></i>
                    </span>
                    ZIP 格式
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-time-line text-[13px]"></i>
                    </span>
                    今天 09:58 更新
                  </span>
                </div>

                <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                  <button
                    type="button"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-download-2-line text-base"></i>
                    </span>
                    立即下载
                  </button>
                  <button
                    type="button"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-list-check-2 text-base"></i>
                    </span>
                    先看目录
                  </button>
                </div>
              </div>
            </div>
          </Reveal>

          <div className="flex flex-col gap-3">
            {downloadPacks.map((pack, index) => (
              <Reveal key={pack.id} delay={index * 60}>
                <div className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100">
                    <i className="ri-file-zip-line text-xl text-accent-800"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h4 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {pack.name}
                      </h4>
                      {pack.hot ? (
                        <span className="shrink-0 rounded bg-primary-100 px-1.5 py-0.5 text-[11px] font-medium text-primary-700">
                          热门
                        </span>
                      ) : null}
                    </div>
                    <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span>{pack.size}</span>
                      <span className="text-background-400">|</span>
                      <span>{pack.format}</span>
                      <span className="text-background-400">|</span>
                      <span>{pack.items} 套</span>
                      <span className="text-background-400">|</span>
                      <span>{pack.updated}</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-3 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-600"
                  >
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-download-line text-[13px]"></i>
                    </span>
                    下载
                  </button>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}